import React from 'react'
import { Modal, Loader } from 'semantic-ui-react'

const Loading = ({ active }) => (
  <Modal open={active} basic>
    <Modal.Content>
      <Loader/>
    </Modal.Content>
  </Modal>
)

export default Loading


// WEBPACK FOOTER //
// ./src/components/common/loading.js